import { render } from "./SettingsTabPrescriptionPresets.vue?vue&type=template&id=4dd68006&scoped=true"
import script from "./SettingsTabPrescriptionPresets.vue?vue&type=script&lang=js"
export * from "./SettingsTabPrescriptionPresets.vue?vue&type=script&lang=js"

import "./SettingsTabPrescriptionPresets.vue?vue&type=style&index=0&id=4dd68006&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd68006"]])

export default __exports__